import { MIN_RETURN_QUANTITY } from '../constants/consumptionReturnTexts';

/**
 * Indica si el drawer de devolución se puede confirmar: cantidades dentro del tope y, al
 * autorizar, datos del documento y evidencia para los materiales sin entrega de origen.
 * @param {Object|null} form Estado del drawer.
 * @param {boolean} canReceive Si el usuario puede recibir devoluciones.
 * @returns {boolean}
 */
export const canSaveReturnForm = (form, canReceive) => {
  if (!form?.items.length) return false;
  const minimum = form.uuid ? 0 : MIN_RETURN_QUANTITY;
  const validQuantities = form.items.every((row) => {
    const quantity = Number(row.quantity);
    return quantity >= minimum && (row.limit == null || quantity <= row.limit);
  });
  if (!validQuantities) return false;
  if (form.uuid) return Boolean(canReceive);
  const hasDocumentData = Boolean(
    form.uuid_project && form.uuid_warehouse && form.responsible.trim() && form.reason.trim()
  );
  return (
    hasDocumentData &&
    form.items.every((row) => row.uuid_consumption_item || form.legacy_evidence.trim())
  );
};
